<template>
    <div class="course__edit_versions_table">
        <component-table
            :labels="[
                {
                    key: 'version',
                    title: 'Version',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'releasedBy',
                    title: 'Released by',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'releaseDate',
                    title: 'Release date',
                    type: 'date',
                    sortable: true
                }
            ]"
            :items="items"
            :component-table-item="CourseEditVersionsTableItem"
            :component-table-collapse-item="CourseEditVersionsTableItemCollapseTable"
            :component-table-collapse-item-active="activeCollapseIndex"
            @emit-collapse="handleCollapse"
        />
    </div>
</template>

<script>
import ComponentTable from '@/components/default/shared/ComponentTable'
import CourseEditVersionsTableItem from '@/components/ebs/courses/edit/CourseEditVersionsTableItem'
import CourseEditVersionsTableItemCollapseTable from '@/components/ebs/courses/edit/CourseEditVersionsTableItemCollapseTable'
export default {
  name: 'course-edit-versions-table',
  components: { ComponentTable },
  data () {
    return {
      activeCollapseIndex: '',
      CourseEditVersionsTableItem,
      CourseEditVersionsTableItemCollapseTable
    }
  },
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    handleCollapse (value) {
      this.activeCollapseIndex = this.activeCollapseIndex !== value ? value : ''
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseaddeditversionstable";
</style>
